import * as _ from 'lodash';

import { IRelativePathHelper } from '../../services/helpers';
import { Dictionary, Group, ValidationPageConfiguration } from '../../models';

export interface IRelativeGroupHelperService {
    getGroup(
        configuration: { isBound?: boolean; referenceGroup?: string; group: string },
        selectedGroup: Group,
        groupsDictionary: Dictionary<Group>
    ): Group;
    getReferenceGroup(
        original: Group,
        validationPageConfigurations: Dictionary<ValidationPageConfiguration>
    ): string;
}

export class RelativeGroupHelperService implements IRelativeGroupHelperService {
    static serviceId = 'relativeGroupHelperService';

    static $inject = ['relativePathHelper'];

    constructor(private _relativePathHelper: IRelativePathHelper) {
    }

    getGroup(
        configuration: { isBound?: boolean; referenceGroup?: string; group: string },
        selectedGroup: Group,
        groupsDictionary: Dictionary<Group>
    ): Group {
        let groupGuid = configuration.group || selectedGroup?.guid;
            if (configuration.isBound && groupGuid && selectedGroup) {
            const fromGroup = groupsDictionary[configuration.referenceGroup];
            const group = groupsDictionary[groupGuid];
            const relative = this._relativePathHelper.getRelativePath(fromGroup.absoluteName, group.absoluteName);
            const toGroup = selectedGroup;
            const newPath = this._relativePathHelper.resolveRelativePath(`${toGroup.absoluteName}/${relative}`);
            const groupList = _.values<Group>(groupsDictionary);
            const found = _.find(groupList, v => v.absoluteName === newPath && (!relative ? v.name === toGroup.name : true));
            groupGuid = found ? found.guid : null;
        }
        let group = groupsDictionary[groupGuid];
        if (!group) {
            group = selectedGroup;
        }
        return group;
    }

    getReferenceGroup(
        original: Group,
        validationPageConfigurations: Dictionary<ValidationPageConfiguration>
    ) {
        const pageConfig = _.find(validationPageConfigurations, vpc => vpc.name === original.type);
        return original.configMode === 0 && pageConfig
            ? pageConfig.referenceGroup
            : original.guid;
    }

}